import { render, staticRenderFns } from "./SwiperCenteredSlides.vue?vue&type=template&id=efa01e04&"
import script from "./SwiperCenteredSlides.vue?vue&type=script&lang=js&"
export * from "./SwiperCenteredSlides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports